export default "<router-outlet>\n\n</router-outlet>\n\n"